<template>
    <header id="master-header" class="d-flex w-100 justify-content-start align-items-center bg-light shadow">
        <div class="h-100 py-2 px-3 d-flex flex-column justify-content-between">
            <div class="header-img">
                <img class="" src="../../assets/naglotech_logo.png" />
            </div>
            <span class="">Secure File Management System</span>
        </div>
    </header>
</template>
<script>
export default {
    data () {
        return {
            test1: 'TEST',
            test2: 'DEV'
        }
    }
}
</script>
<style scoped lang="scss">
    #master-header {
        height: 100px;
        z-index: 9;
    }

    .header-img {
        height: 65%;
    }

    img {
        height: 100%;
        width: auto;
    }

    span {
        color: #aaaaaa;
        display: block;
        text-align: center;
        text-transform: uppercase;
    }
</style>


// WEBPACK FOOTER //
// src/components/master/master-header.vue